/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth


(function (Drupal) {
Drupal.behaviors.mainMenu = {
  attach: function (context) {
    'use strict';

    // Use context instead of document IF DRUPAL.
    var toggle_expand = document.getElementById('toggle-expand');
    var menu = document.getElementById('main-nav');
    var expand_menu = menu.getElementsByClassName('expand-sub');

    var body = document.querySelector('body');
    var header = document.querySelector('.header.mega-menu');
    var menuItem = menu.querySelectorAll('.main-menu.level-0 > .main-menu__item');

    var subscribeButton = menu.querySelector(".main-menu__link.subscribe")


    if(!toggle_expand.classList.contains('click-events-added')){
      // Mobile Menu Show/Hide.
      toggle_expand.addEventListener('click', function (e) {
        toggle_expand.classList.toggle('toggle-expand--open');
        menu.classList.toggle('main-nav--open');
        document.body.classList.toggle('main-nav-open');
      });

      // Expose mobile sub menu on click.
      for (var i = 0; i < expand_menu.length; i++) {
        expand_menu[i].addEventListener('click', function (e) {
          var menu_item = e.currentTarget;
          var sub_menu = null;
          var sibling = menu_item.nextElementSibling;
          while (sibling && sub_menu == null) {
            if (sibling.matches('ul'))
              sub_menu = sibling;
            sibling = sibling.nextElementSibling
          }

          menu_item.classList.toggle('expand-sub--open');
          sub_menu.classList.toggle('main-menu--sub-open');
        });
      }
    }
    toggle_expand.classList.add('click-events-added');

    for (var i = 0; i < menuItem.length; i++) {
      menuItem[i].addEventListener("mouseenter", function (e) {
        body.classList.add('body-menu-hover');
        body.classList.remove('body-menu-hover-fade-out');
        header.classList.add('menu-hover');
      });

      menuItem[i].addEventListener("mouseleave", function (e) {
        body.classList.remove('body-menu-hover');
        body.classList.add('body-menu-hover-fade-out');
        header.classList.remove('menu-hover');
      });
    }

    if (subscribeButton) {
      subscribeButton.parentElement.classList.add('btn-subscribe')

      subscribeButton.parentElement.addEventListener("mouseenter", function(){
      body.classList.remove('body-menu-hover');
      body.classList.add('body-menu-hover-fade-out');
      // header.classList.remove('menu-hover');
    }) 
    }
  }
}
})(Drupal);
